import { render } from "./App.vue?vue&type=template&id=2732d68d&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2732d68d&lang=scss"

import exportComponent from "C:\\dev\\laragon\\www\\test-interactiv\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__